//
import * as actions from './actions';
import reducer from './reducers';
import * as selectors from './selectors';
import * as types from './types';

const userStore = {
  actions,
  reducer,
  selectors,
  types
};

export default userStore;
